export default __webpack_public_path__ + "9b7f1c001ab13966c763ca7123669ee2.svg";